import { render, staticRenderFns } from "./PodPrikrutiem.vue?vue&type=template&id=351941ef&scoped=true"
import script from "./PodPrikrutiem.vue?vue&type=script&lang=js"
export * from "./PodPrikrutiem.vue?vue&type=script&lang=js"
import style0 from "./PodPrikrutiem.vue?vue&type=style&index=0&id=351941ef&prod&lang=scss&scoped=true"
import style1 from "./PodPrikrutiem.vue?vue&type=style&index=1&id=351941ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351941ef",
  null
  
)

export default component.exports